import {defineAsyncComponent} from 'vue';

export const HitButton = defineAsyncComponent(() => import('./HitButton.vue'));
export const HitButtonAdd = defineAsyncComponent(
  () => import('./HitButtonAdd.vue'),
);
export const HitButtonDelete = defineAsyncComponent(
  () => import('./HitButtonDelete.vue'),
);
export const HitButtonPrint = defineAsyncComponent(
  () => import('./HitButtonPrint.vue'),
);
